var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"app-footer"},[_c('div',{staticClass:"footer"},[_vm._v("Copyright© Edu Tek Company Limited All Rights Reserved")])])}]

export { render, staticRenderFns }